const noop = () => {};

const consoleTarget =
  process.env.NODE_ENV === "production"
    ? {
        error: noop,
        warn: noop,
        log: noop,
        info: noop,
        debug: noop,
      }
    : console;

const logger = {
  error: (...args) => consoleTarget.error(...args),
  warn: (...args) => consoleTarget.warn(...args),
  log: (...args) => consoleTarget.log(...args),
  info: (...args) => consoleTarget.info(...args),
  debug: (...args) => consoleTarget.debug(...args),
};

export default logger;
